<template>
    <v-autocomplete
        ref="autocomplete"
        v-model="emails"
        :chips="multiple"
        closable-chips
        :multiple="multiple"
        :hide-details="hideDetails"
        variant="outlined"
        :label="label"
        hide-no-data
        hide-selected
        :density="dense ? 'compact' : 'comfortable'"
        no-filter
        :items="items"
        append-icon=""
        :rules="rules"
        @update:search="updateSearchInput"
        @keydown="keydown"
        @update:model-value="input"
    />
</template>

<script lang="ts">
    import {Component, mixins, Prop, VModel, Watch} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    // TODO [P1] Need check
    @Component
    export class EmailField extends mixins(FormValidationRulesMixin) {
        @VModel() emails
        @Prop() label
        @Prop({default: false, type: Boolean}) required
        @Prop({default: false, type: Boolean}) hideDetails
        @Prop({default: false, type: Boolean}) dense
        // TODO [P4] Need remove multiple as unusable
        @Prop({default: true, type: Boolean}) multiple

        items = []

        @Watch('emails')
        onEmailsChange(emails) {
            this.items = this.multiple ? emails : [emails]
        }

        mounted() {
            this.items = this.multiple ? this.emails : [this.emails]
        }

        updateSearchInput(val) {
            this.searchInput = val
            const emailsArray = this.multiple ? this.emails : [this.emails]

            if (this.emailRule()(val) === true && !emailsArray.includes(val) && val?.trim()?.length) {
                this.items = [val, ...emailsArray]
            } else {
                this.items = emailsArray
            }
        }

        keydown(event) {
            const emailsArray = this.multiple ? this.emails : [this.emails]

            if (
                ['Enter', 'NumpadEnter', 'Space', 'Comma'].includes(event.code) &&
                this.emailRule()(this.searchInput) === true &&
                !emailsArray.includes(this.searchInput)
            ) {
                if (this.multiple) {
                    this.emails.push(this.searchInput)
                } else {
                    this.emails = [this.searchInput]
                }

                this.searchInput = ''
            }
        }

        input() {
            this.searchInput = ''
        }

        get rules() {
            if (this.multiple) {
                return this.required ? [v => !!v.length || `${this.label} ${this.$t('validation.required')}`] : []
            } else {
                return this.required ? [v => !!v || `${this.label} ${this.$t('validation.required')}`] : []
            }
        }

        get searchInput() {
            return this.$refs.autocomplete.search
        }

        set searchInput(val) {
            this.$refs.autocomplete.search = val
        }
    }

    export default EmailField
</script>
